"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryGenerateSubtitlesSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, language, failureDescription }) {
        super({
            result,
            statusCode,
            failureDescription,
            componentName: 'GENEREATE_SUBTITLES_BUTTON',
            componentSource: 'GENEREATE_SUBTITLES_BUTTON'
        });
        this.action = baseSchema_1.ActionsName.TRY_GENERATE_SUBTITLES;
        this.language = language;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            language: this.language
        };
    }
}
exports.default = TryGenerateSubtitlesSchema;
